import { CognitoUser, AuthenticationDetails } from "amazon-cognito-identity-js";
import Pool from "../Config/UserPool";
import { jwtDecode } from "jwt-decode";

export const authenticate = async (dispatch, Username, Password) => {
  return await new Promise((resolve, reject) => {
    dispatch({ type: "REQUEST_LOGIN" });
    const user = new CognitoUser({ Username, Pool });
    user.setAuthenticationFlowType("USER_PASSWORD_AUTH");
    const authDetails = new AuthenticationDetails({
      Username,
      Password
    });
    user.authenticateUser(authDetails, {
      onSuccess: (data) => {
        dispatch({ type: "LOGIN_SUCCESS", data });
        console.log("onSuccess: ");
        resolve(data);
      },
      onFailure: (err) => {
        dispatch({ type: "LOGIN_ERROR", error: err.message });
        console.error("onFailure", err.message);
        reject(err.message);
      },
      newPasswordRequired: (data) => {
        dispatch({ type: "NEW_PASSWORD_REQUIRED", user });
        console.log("newPasswordRequired: ", data);
        resolve(data);
      },
      mfaRequired: (data) => {
        dispatch({ type: "MFA_REQUIRED", user });
        console.log("MFA is required:", data);
        resolve(data);
      },
    });
  });
};

export const checkSession = async (dispatch, callback) => {
  return await new Promise((resolve, reject) => {
    const user = Pool.getCurrentUser();
    if (user) {
      user.getSession((err, session) => {
        if (err) {
          console.error(err);
          dispatch({
            type: "CHECK_SESSION",
            isAuthenticated: false,
            session: null,
            userGroup: null,
          });
          reject(err);
        } else if (session.isValid()) {
          console.log("current session valid");
         
          const idToken = session.getIdToken().getJwtToken();
          const decodedToken = jwtDecode(idToken);
          const userGroups = decodedToken['cognito:groups'] || [];
          const firstGroupAsList = userGroups.length > 0 ? [userGroups[0]] : [];


          dispatch({
            type: "CHECK_SESSION",
            isAuthenticated: true,
            session: session,
            userGroup: firstGroupAsList,
          });
          resolve(session);
        } else {
          console.log("session invalid");
          dispatch({
            type: "CHECK_SESSION",
            isAuthenticated: false,
            session: null,
            userGroup: null,
          });
          reject(new Error("current session not valid"));
        }
      });

      // Add a delay to simulate the network request
      // setTimeout(() => {
      //   user.getSession((err, session) => {
      //     if (err) {
      //       console.error(err);
      //       dispatch({ type: "CHECK_SESSION", isAuthenticated: false, session: null });
      //       reject(err);
      //     } else if (session.isValid()) {
      //       console.log('Current session valid');
      //       dispatch({ type: "CHECK_SESSION", isAuthenticated: true, session: session });
      //       resolve(session);
      //     } else {
      //       console.log("Session invalid");
      //       dispatch({ type: "CHECK_SESSION", isAuthenticated: false, session: null });
      //       reject(new Error("Current session not valid"));
      //     }
      //   });
      // }, 3000); // 3000 milliseconds or 3 seconds delay
    } else {
      dispatch({
        type: "CHECK_SESSION",
        isAuthenticated: false,
        session: null,
        userGroup: null,
      });
      reject(new Error("no existing user session"));
    }
  });
};

export const logout = async (dispatch, queryClient) => {
  return await new Promise((resolve, reject) => {
    const user = Pool.getCurrentUser();
    if (user) {
      user.signOut();
      dispatch({ type: "LOGOUT" });
      resolve();
    } else {
      reject(new Error("No user is currently signed in."));
    }
  });
};

export const getUserInfo = async (dispatch) => {
  return await new Promise((resolve, reject) => {
    const user = Pool.getCurrentUser();
    console.log("getting user attributes");
    if (user) {
      user.getSession((err, session) => {
        if (err) {
          console.error(err);
          // dispatch({ type: "GET_USER_INFO_ERROR", error: err });
          reject(err);
        } else if (session.isValid()) {
          user.getUserAttributes((err, attributes) => {
            if (err) {
              // Handle error
              console.error(err);
              // dispatch({ type: "GET_USER_INFO_ERROR", error: err });
              reject(err);
            } else {
              // Attributes is an array of user attribute objects
              // We want to transform this into a more usable object
              console.log(attributes);
              const userAttributes = attributes.reduce((acc, attribute) => {
                acc[attribute.getName()] = attribute.getValue();
                return acc;
              }, {});

              dispatch({ type: "GET_USER_INFO_SUCCESS", userAttributes });
              resolve(userAttributes);
            }
          });
        } else {
          // dispatch({ type: "GET_USER_INFO_ERROR", error: new Error("Session is invalid") });
          reject(new Error("Session is invalid"));
        }
      });
    } else {
      // dispatch({ type: "GET_USER_INFO_ERROR", error: new Error("No user is currently signed in.") });
      reject(new Error("No user is currently signed in."));
    }
  });
};

export const completeEnforcePasswordChange = (dispatch, newPassword, user) => {
  return new Promise((resolve, reject) => {
    if (user) {
      user.completeNewPasswordChallenge(newPassword, [], {
        onSuccess: (data) => {
          console.log(data);
          dispatch({ type: "LOGIN_SUCCESS", data });
          resolve(data);
        },
        onFailure: (err) => {
          console.log(err);
          dispatch({ type: "LOGIN_ERROR", error: err.message });
          reject(err);
        },
        mfaRequired: (data) => {
          dispatch({ type: "MFA_REQUIRED", user });
          console.log("MFA is required:", data);
          resolve(data);
        },
        customChallenge: (data) => {
          console.log("Custom challenge:", data);
          // dispatch({ type: 'CUSTOM_CHALLENGE', data });
          // reject(data);
        },
      });
    } else {
      const error = new Error("cannot create user from username");
      reject(error);
    }
  });
};

export const verifyMFA = (dispatch, user, code) => {
  return new Promise((resolve, reject) => {
    if (user) {
      user.sendMFACode(code, {
        onSuccess: (result) => {
          dispatch({ type: "LOGIN_SUCCESS", data: result });
          console.log("MFA code verified successfully:", result);
          resolve(result);
        },
        onFailure: (err) => {
          dispatch({ type: "LOGIN_ERROR", error: err.message });
          console.error("Failed to verify MFA code:", err);
          reject(err);
        },
      });
    } else {
      const error = new Error(
        "No Cognito user instance available for MFA verification."
      );
      console.error(error.message);
      reject(error);
    }
  });
};
